import { GANHE_MAIS_CORRETOR_CLIENT_URL } from '../../constants/ClientUrls';
import { useAuth } from '../../hooks/useAuth';
import styles from './style.module.css';

export function Copyright() {
  const { client } = useAuth();
  if (client?.clientUrl === GANHE_MAIS_CORRETOR_CLIENT_URL) return null;

  return (
    <>
      <div className={`d-none d-lg-block ${styles.footer}`}>
        <hr />
        <div className="container-fluid">
          <div className="container">
            <div className="pb-3">
              <img
                className="float-start me-3 grey-logo"
                src="https://oqdigital.com/img/logo.png"
                width={40}
                alt=""
              />
              <p className="my-0">
                Copyright © {new Date().getFullYear()} by OQ Digital
              </p>
              <span>
                All rights reserved. |{' '}
                <a href="https://oqdigital.com">oqdigital.com</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
